import { render, staticRenderFns } from "./UserDebug.vue?vue&type=template&id=4b3995be&scoped=true&"
import script from "./UserDebug.vue?vue&type=script&lang=js&"
export * from "./UserDebug.vue?vue&type=script&lang=js&"
import style0 from "./UserDebug.vue?vue&type=style&index=0&id=4b3995be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3995be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
